import React, {Fragment} from 'react';
import {connect} from "react-redux";
import {companiesUpdated} from "../../actions/companyAction";
import {translate} from "react-i18next";
import CompanyApi from "../../apis/CompanyApi";

class DeleteQuota extends React.Component {

    state = {
        loading: false,
        isOpen: false
    };

    open = () => {
        this.setState({isOpen: true});
    };

    cancel = () => {
        this.setState({isOpen: false});
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({loading: true});
        CompanyApi.deleteCompanyProjectQuota(this.props.id)
            .then((response) => {
                if (response.status === 200) {
                    this.setState({loading: false});
                    this.cancel();
                    this.props.companiesUpdated();
                    this.props.onSuccess();
                }
            })
    };

    render() {

        const {t} = this.props;

        return (
            <Fragment>
                <button className="btn btn-xs btn-warning" onClick={this.open}>
                    <i className="fa fa-trash"/>
                </button>
                {this.state.isOpen ? (
                    <div className="DeleteQuotaDialog modal inmodal in text-left" tabIndex="-1" role="dialog"
                         style={{display: 'block'}}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button className="close" onClick={this.cancel}>
                                        <span>x</span>
                                    </button>
                                    <h4 className="modal-title">
                                        {t('company.companyProject.quota.delete.title')}
                                    </h4>
                                </div>
                                <form onSubmit={this.handleSubmit}>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-xs-12">
                                                <strong>
                                                    {t('company.companyProject.quota.delete.text')}
                                                </strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-default" onClick={this.cancel}
                                                disabled={this.state.loading}>
                                            {t('default.cancel')}
                                        </button>
                                        <button className="btn btn-danger" type="submit" disabled={this.state.loading}>
                                            {this.state.loading ? (
                                                <i className='fa fa-spinner fa-spin inline-block m-r'/>
                                            ) : null}
                                            {t('default.delete')}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                ) : null}
            </Fragment>
        )
    }
}

export default connect(null, {companiesUpdated})(translate()(DeleteQuota));
